.card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 4px 8px;
  text-decoration: none;
  cursor: pointer;
  width: 100%;
  border-radius: 8px;

  &:hover {
    background: var(--dark-2);
  }
}

.content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
